import React from 'react';
import { menuListItems } from '../../assets/menu/menuList';
import { Menu } from '../../components/Menu';
import { TicketIngestionBatches } from './TicketIngestionBatches';
import { TicketIngestionsTable } from './TicketIngestionsTable';
import { Container } from './styles';

export const TicketIngestions: React.FC = () => {
  return (
    <Menu links={menuListItems}>
      <Container>
        <TicketIngestionBatches />
      </Container>
      <Container>
        <TicketIngestionsTable />
      </Container>
    </Menu>
  );
};
